import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function irwinIdValidator(
  control: AbstractControl
): ValidationErrors | null {
  const IRWIN_ID_REGEXP =
    /[a-zA-Z\d]{8}-[a-zA-Z\d]{4}-[a-zA-Z\d]{4}-[a-zA-Z\d]{4}-[a-zA-Z\d]{12}/;
  const isValid = IRWIN_ID_REGEXP.test(control.value) || control.value === "";
  return isValid ? null : { invalidIrwinId: "true" };
}
